<div [ngClass]="containerClass">
  <div class="row ribbon-row">
    <ng-content></ng-content>
  </div>
</div>
<ng-content select="[containerSlot]"></ng-content>
